<template>
  <app-modal
    :shown="shown"
    @close="handleClose"
    class="modal-login">
    <div class="center-content-position">
      <div
        v-if="errorMessage"
        class="alert alert-danger">{{ errorMessage }}
      </div>
      <div v-if="!recoverMode">
        <h1>Login</h1>
        <form name="form" @submit.prevent="handleLogin" role="form">
          <div class="form-group" :class="{'has-error': errors.has('username')}">
            <label for="username">Email</label>
            <input
              key="username-base"
              type="text"
              name="username"
              id="username"
              class="form-control"
              v-model="username"
              v-validate="'required'"
              required />
            <span v-if="errors.has('username')" class="help-block">Email is required</span>
          </div>
          <div class="form-group" :class="{'has-error': errors.has('password')}">
            <label for="password">Password</label>
            <input
              key="password-base"
              type="password"
              name="password"
              id="password"
              class="form-control"
              v-model="password"
              v-validate="'required'"
              required />
            <span v-if="errors.has('password')" class="help-block">Password is required</span>
          </div>
          <div class="form-actions">
            <button type="submit" :disabled="errors.any() || isLoading" class="cta-button">Login</button>
            <img v-if="isLoading" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="
            />
            <a @click="displayRegister" class="btn btn-link">Create New Account</a>
            <a @click="recoverMode=true" class="btn btn-link">Recover password</a>
          </div>
        </form>
      </div>

      <div v-if="recoverMode">
        <h1>Recover Password — Step 1</h1>
        <div v-if="!isRecoveryStarted">
          <p style="padding-bottom: 0; color: #B0B1BA;">Provide the email that you used to register account, and we will initiate a password reset.</p>
          <form name="formRecover" @submit.prevent="recoverPassword" role="form">
            <div class="form-group" :class="{'has-error': errors.has('email')}">
              <label for="email">Email</label>
              <input
                key="username-recover"
                type="text"
                name="email"
                id="email"
                class="form-control"
                v-model="email"
                v-validate="'required|email'"
                required />
              <span v-if="errors.has('email')" class="help-block">Email is required</span>
            </div>
            <div class="form-actions">
              <button type="submit" :disabled="errors.any() || isLoading" class="cta-button">Recover Password</button>
              <img v-if="isLoading" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="
              />
              <a @click="recoverMode=false" class="btn btn-link">Login now</a>
            </div>
          </form>
        </div>
        <div v-if="isRecoveryStarted">
          <p style="color: #666;">An email has been sent to {{ email }}, please follow instructions in that email.</p>
          <button type="button" class="btn btn-default" @click="handleClose">OK</button>
        </div>
      </div>
    </div>
  </app-modal>
</template>

<script>
import { mapActions } from 'vuex'
import auth from '../../../services/auth.service.js'
import appModal from '../common/app-modal.vue'

export default {
  name: 'modal-login',
  components: {
    appModal,
  },
  props: ['shown', 'recovery'],
  data() {
    return {
      username: '',
      password: '',
      email: '',
      recoverMode: false,
      isLoading: false,
      isRecoveryStarted: false,
      errorMessage: '',
    }
  },
  mounted() {
    if (this.recovery) {
      this.recoverMode = true
    }
  },
  watch: {
    recovery(v) {
      if (v) {
        this.recoverMode = true
      }
    },
  },
  methods: {
    ...mapActions({
      showModal: 'showModal',
      hideModal: 'hideModal',
      login: 'login',
    }),
    handleClose() {
      this.recoverMode = false
      this.isRecoveryStarted = false
      this.isLoading = false
      this.$emit('close')
    },
    handleLogin() {
      this.isLoading = true
      this.errorMessage = ''
      const { username, password } = this
      this.login({ login: username, password })
        .then(res => {
          this.clearFields()
          this.$nextTick(() => {
            this.isLoading = false
            this.hideModal()
          })
        })
        .catch(err => {
          this.isLoading = false
          this.errorMessage = err.response
            ? err.response.data.message
            : err.message
          this.$log(err)
        })
    },
    displayRegister() {
      this.showModal('register')
    },
    showRecoverMode() {
      this.recoverMode = true
    },
    recoverPassword() {
      this.errorMessage = ''
      this.isLoading = true
      const login = this.email
      auth
        .resetPassword({ login })
        .then(res => {
          this.isRecoveryStarted = true
          this.isLoading = false
        })
        .catch(err => {
          this.errorMessage = err.response
            ? err.response.data.message
            : err.message
          this.isLoading = false
          this.$log(err)
        })
    },
    clearFields() {
      this.username = ''
      this.password = ''
    },
  },
}
</script>

<style scoped>
.center-content-position {
  width: 80% !important;
}
.form-actions {
  text-align: center;
}
.has-error .form-control {
  box-shadow: none;
}
</style>
